import React, { useState } from 'react';
import { ExternalLink, Github, Calendar, Sparkles } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import './Filmography.css';

const Filmography = () => {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 7,
      title: 'SH Transport',
      subtitle: 'Site Web Professionnel',
      description: 'Site web complet pour une entreprise de transport. Conception et développement front-end.',
      image: 'https://images.unsplash.com/photo-1772429961738-94354a601084',
      category: 'Web',
      year: 'Janvier 2026',
      duration: 'Projet Pro',
      tech: ['React', 'HTML', 'CSS', 'JavaScript'],
      demo: 'https://www.shtransport.fr',
    },
    {
      id: 1,
      title: 'Planification d’Activités',
      subtitle: 'Algorithmes sous contraintes',
      description: 'Développement d’une application de planification. Implémentation d’algorithmes de tri topologique.',
      image: 'https://images.unsplash.com/photo-1760385737072-3b59d152c352',
      category: 'Algorithmes',
      year: 'Décembre 2025',
      duration: 'Projet Académique',
      tech: ['Java', 'POO', 'Tri topologique'],
      github: 'https://github.com/Omar-Aldroubi/scheduling',
    },
    {
      id: 3,
      title: 'Bataille Navale',
      subtitle: 'Architecture MVC & Swing',
      description: 'Jeu de bataille navale réalisé en Java, basé sur une architecture MVC, avec une interface graphique en Swing.',
      image: 'https://images.unsplash.com/photo-1676090438227-141cac59c405',
      category: 'Jeux',
      year: 'Avril 2025',
      duration: 'Projet Académique',
      tech: ['Java', 'MVC', 'Swing'],
      github: 'https://github.com/Omar-Aldroubi/Bataille-Navale',
    },
    {
      id: 5,
      title: 'Mini-Site CRUD',
      subtitle: 'Gestion de Base de Données',
      description: "Il s'agit d'une application CRUD complète développée en PHP permettant de gérer une base de données de recettes et de plats.",
      image: 'https://media.istockphoto.com/id/1293479617/fr/photo/mains-de-femme-mangeant-la-salade-v%C3%A9g%C3%A9talienne-des-l%C3%A9gumes-cuits-au-four-avocat-tofu-et-bol.jpg?s=612x612&w=0&k=20&c=80yjT-rle9PBH7XAUZejnk4UQv3j8e20WZKAjkdPixQ=',
      category: 'Web',
      year: 'Avril 2025',
      duration: 'Projet Académique',
      tech: ['PHP', 'MySQL', 'HTML'],
      github: 'https://github.com/Omar-Aldroubi/mini-site-SCRUD',
    },
    {
      id: 2,
      title: 'Corewar Simulator',
      subtitle: 'Machine Virtuelle',
      description: 'Projet complexe simulant des combats de programmes dans une machine virtuelle.',
      image: 'https://images.pexels.com/photos/7862491/pexels-photo-7862491.jpeg',
      category: 'Simulation',
      year: 'Mars 2025',
      duration: 'Projet Académique',
      tech: ['Java', 'POO'],
      github: 'https://github.com/Omar-Aldroubi/Corewar-Simulator',
    },
    {
      id: 4,
      title: 'Morpion (Tic-Tac-Toe)',
      subtitle: 'Intelligence Artificielle Simple',
      description: 'Implémentation d’un jeu de morpion avec une logique détectant les "cases menaçantes" pour empêcher l’adversaire de gagner.',
      image: 'https://st2.depositphotos.com/3228285/5612/i/450/depositphotos_56120421-stock-photo-tic-tac-toe.jpg',
      category: 'Jeux',
      year: 'Décembre 2024',
      duration: 'Projet Académique',
      tech: ['Java', 'POO'],
      github: 'https://github.com/Omar-Aldroubi/jeu-de-morpion',
    },
    {
      id: 6,
      title: 'App Graphique Multi-jeux',
      subtitle: 'Simulations & Mini-jeux',
      description: 'Application Python avec interface graphique (Tkinter). Intégration de plusieurs simulations : Snake, Jeu de la vie (Conway)...',
      image: 'https://www.snake.fr/images/google-snake-jeu.png',
      category: 'Jeux',
      year: 'Mai 2024',
      duration: 'Projet Académique',
      tech: ['Python', 'POO', 'Tkinter'],
      github: 'https://github.com/Omar-Aldroubi/python-mini-games',
    }
  ];

  const categories = ['all', 'Jeux', 'Web', 'Simulation', 'Algorithmes'];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(p => p.category === filter);

  return (
    <section id="filmography" className="filmography">
      <div className="filmography-container">
        
        {/* L'EN-TÊTE MODERNE QUE TU AS DEMANDÉ */}
        <div className="modern-section-header">
          <div className="modern-badge">
            <Sparkles size={16} />
            <span>Portfolio</span>
          </div>
          <h2 className="modern-title">
            Mes <span className="modern-highlight">Projets</span>
          </h2>
          <p className="modern-subtitle">
            Découvrez mes créations : des jeux, des sites web et des outils intelligents
          </p>
        </div>

        <div className="filter-buttons">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`filter-btn ${filter === cat ? 'active' : ''}`}
            >
              {cat === 'all' ? 'Tous' : cat}
            </button>
          ))}
        </div>

        {/* TON ANCIENNE GRILLE DE PROJETS */}
        <div className="projects-grid">
          {filteredProjects.map((project) => (
            <Card key={project.id} className="project-card">
              <div className="project-image-container">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="project-image"
                />
                
                {/* TON BADGE DATE CYAN */}
                <div className="custom-date-badge">
                  <Calendar size={14} />
                  <span>{project.year}</span>
                </div>

                <div className="project-overlay">
                  <div className="project-genre">{project.genre}</div>
                </div>
              </div>
              
              <div className="project-content">
                <div className="project-meta">
                  <span className="project-duration">{project.duration}</span>
                  <span className="project-category">{project.category.toUpperCase()}</span>
                </div>
                
                <h3 className="project-title">{project.title}</h3>
                <p className="project-subtitle">Réalisé par Omar Aldroubi</p>
                <p className="project-description">{project.description}</p>
                
                <div className="project-tech">
                  <div className="tech-label">TECHNOLOGIES:</div>
                  <div className="tech-list">
                    {project.tech.map((tech, idx) => (
                      <Badge key={idx} variant="outline" className="tech-badge">
                        {tech}
                      </Badge>
                    ))}
                  </div>
                </div>
                
                {/* TES BOUTONS CACHÉS AU SURVOL */}
                <div className="project-actions">
                  {project.github && (
                    <a 
                      href={project.github} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="project-link"
                    >
                      <Github size={18} />
                      <span>Voir le projet</span>
                    </a>
                  )}
                  {project.demo && (
                    <a 
                      href={project.demo} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="project-link demo"
                    >
                      <ExternalLink size={18} />
                      <span>Voir le projet</span>
                    </a>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Filmography;